module.exports = __webpack_public_path__ + "static/media/014.ba91347c.jpg";